<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM9.29 16.2902L5.7 12.7002C5.31 12.3102 5.31 11.6802 5.7 11.2902C6.09 10.9002 6.72 10.9002 7.11 11.2902L10 14.1702L16.88 7.29018C17.27 6.90018 17.9 6.90018 18.29 7.29018C18.68 7.68018 18.68 8.31018 18.29 8.70018L10.7 16.2902C10.32 16.6802 9.68 16.6802 9.29 16.2902Z"
  />
</template>
